<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Half Title">
<p class="half"><span class="right_1" epub:type="pagebreak" id="page_xxix" title="xxix">H<span class="small">ABITS OF</span> W<span class="small">HITENESS</span><span class="right_1" epub:type="pagebreak" id="page_xxx" title="xxx"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253059833_Halftitle01.vue?16eb797a